export interface VideoExportJobRequest {
  episodeId: string;
  format?: 'mp4' | 'mov';
  quality?: 'low' | 'medium' | 'high';
  resolution?: string;
  fps?: number;
}

export interface VideoExportJobResponse {
  jobId: string;
  status: VideoExportJobStatus;
  message: string;
}

export interface VideoExportStatusResponse {
  jobId: string;
  status: VideoExportJobStatus;
  progress: number; // 0-100
  videoUrl?: string;
  subtitleUrl?: string;
  error?: string;
  createdAt: Date;
  updatedAt: Date;
}

import { I18nLabels } from './common';
import { Locale } from './locale';

export enum VideoExportJobStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed'
}

export const VideoExportJobStatusLabels: I18nLabels<VideoExportJobStatus> = {
  [VideoExportJobStatus.PENDING]: { [Locale.ZH_CN]: '等待中', [Locale.EN_US]: 'Pending' },
  [VideoExportJobStatus.PROCESSING]: { [Locale.ZH_CN]: '处理中', [Locale.EN_US]: 'Processing' },
  [VideoExportJobStatus.COMPLETED]: { [Locale.ZH_CN]: '已完成', [Locale.EN_US]: 'Completed' },
  [VideoExportJobStatus.FAILED]: { [Locale.ZH_CN]: '失败', [Locale.EN_US]: 'Failed' },
};

// 阿里云剪辑时间轴配置
export interface AliyunTimelineConfig {
  VideoTracks: AliyunVideoTrack[];
  AudioTracks: AliyunAudioTrack[];
}

export interface AliyunVideoTrack {
  VideoTrackClips: AliyunVideoClip[];
}

export interface AliyunAudioTrack {
  AudioTrackClips: AliyunAudioClip[];
}

export interface AliyunVideoClip {
  MediaURL: string;
  TimelineIn: number;
  TimelineOut: number;
  Type?: string;
  Effects?: AliyunVideoEffect[];
}

export interface AliyunAudioClip {
  MediaURL: string;
  TimelineIn: number;
  TimelineOut?: number;
  LoopMode?: boolean;
  Effects?: AliyunAudioEffect[];
}

export interface AliyunVideoEffect {
  Type: string;
  SubType?: string;
}

export interface AliyunAudioEffect {
  Type: string;
  Gain?: number;
  Font?: string;
  Alignment?: string;
  Y?: number;
  Outline?: number;
  OutlineColour?: string;
  FontSize?: number;
  FontColor?: string;
  FontFace?: {
    Bold: boolean;
    Italic: boolean;
    Underline: boolean;
  };
}